import {HttpClient, HttpHeaders} from '@angular/common/http';
import {EventEmitter, Injectable} from '@angular/core';
import {UserRoleModel} from '../dto/user-role.model';
import {Observable} from 'rxjs/internal/Observable';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class UserRoleService {
  userRoleSearchDetailsChange = new EventEmitter<UserRoleModel[]>();

  private userRoleSearchDetailsItem: UserRoleModel[] = [];
  public BASE_URL = this.appConfig.getConfig('BASE_URL') + 'api/';
  private headers = new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8'
  });

  constructor(private httpClient: HttpClient, private appConfig: AppConfig) {
  }

  /** get all user role details **/
  getAllUserRoles(){
    return this.httpClient.get(this.BASE_URL + 'user-role/all');
  }

  /** save user role details **/
  saveUserRole(userRole: UserRoleModel){
    return this.httpClient.post(this.BASE_URL + 'user-role/save' , userRole,{responseType: 'text'});
  }

  /** search user role details **/
  getSearchResult(userRoleModel: UserRoleModel): Observable<Object> {
    return this.httpClient.post(this.BASE_URL + 'user-role/', userRoleModel, { headers: this.headers });
  }

  /** delete user role details **/
  deleteUserRole(id: string) {
    return this.httpClient.delete(this.BASE_URL + 'user-role/delete/'+id, { headers: this.headers });
  }

  /** reset searched details **/
  clearUserRoleSearchDetails() {
    this.userRoleSearchDetailsItem = [];
    this.userRoleSearchDetailsChange.emit(this.userRoleSearchDetailsItem);
  }

  /** set search details in the table **/
  setUserRoleSearchDetails(userRoleSearchDetails: UserRoleModel[]) {
    this.userRoleSearchDetailsItem = userRoleSearchDetails;
    this.userRoleSearchDetailsChange.emit(this.userRoleSearchDetailsItem);
  }

}
